import { MarketplaceRetailerLink } from '../../types/marketplace-retailer-link'
import { ImageTypes } from '../../types/images'

function graphqlToMarketplaceRetailerLink(item: any): MarketplaceRetailerLink {
  const logoUrl =
    item?.retailerLogoSet?.tileBackground?.url ||
    item?.retailerLogoSet?.coloured?.url ||
    item?.retailerLogoSet?.transparent?.url ||
    ''
  return {
    imageType: ImageTypes.Square,
    imageUrl: logoUrl,
    logoUrl,
    alternativeLogoUrls: {
      tile: item?.retailerLogoSet?.tileBackground?.url,
      coloured: item?.retailerLogoSet?.coloured?.url,
      transparent: item?.retailerLogoSet?.transparent?.url,
    },
    title: item.title,
    url: `/store/${item.sys.id}/${item.slug}`,
    shortDescription: item.shortDescription,
  }
}

export function graphqlToMarketplaceRetailerReducer(
  items: any[],
  item: any
): MarketplaceRetailerLink[] {
  if (item.marketplaceShopSlug === null) {
    return items
  }

  return [...items, graphqlToMarketplaceRetailerLink(item)]
}
